import React, { useState, useEffect, useMemo, useCallback } from "react";
import { LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useErrorNotification } from "@common/components/Notification";
import Form from "./components";
import { Account, BillingCode, Type } from "@services/account/types";
import { getAccount } from "@services/account";
import { ContentProps } from "./const";
import getFields from "./getFields";

const Content = (props: ContentProps) => {
  const { participant, onChange, emptyDialOption = false } = props;
  const context = React.useContext(RoomsRealtimeContext);
  const dispatchError = useErrorNotification();
  const meeting = context.detail?.meeting;
  const { t } = useTranslation();
  const [billingCodes = [], setBillingCodes] = useState<BillingCode[]>();
  const fetchBillingCodes = useCallback(
    async (id: Account["id"]) => {
      try {
        let codes = (
          (await getAccount(id)).details?.accountBillingCodes ?? []
        ).filter(({ type, active }) => active && type === Type.PASSTHROUGH);

        const found = codes.find(
          (x) => x.billingCode === participant.billingCode
        );
        if (found === undefined && participant.billingCode !== undefined) {
          // Case handled through `bWeird` in SY 5
          codes = [
            ...codes,
            {
              billingCode: participant.billingCode,
              description: participant.description,
            },
          ];
        }
        setBillingCodes(codes);
      } catch (e) {
        dispatchError(e);
      }
    },
    [participant.billingCode]
  );
  useEffect(() => {
    if (meeting && meeting.account) fetchBillingCodes(meeting.account?.id);
  }, [meeting]);

  return meeting === undefined ? (
    <LinearProgress />
  ) : (
    <Form
      fields={getFields({
        emptyDialOption,
        participant,
        onChange,
        meeting,
        t,
        billingCodes,
      })}
    />
  );
};

export default Content;
